var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"dropdown-content"}},[(_vm.active)?_c('div',{class:`absolute right-0 ${_vm.dropdownwidth} ${_vm.dropdownMargin} ${_vm.dropdownTop} origin-top-right bg-white border   z-40 rounded-lg`,staticStyle:{"box-shadow":"0 0 10px rgb(0 0 0 / 28%)"}},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }